import { useState } from 'react';

import { ISoftphoneModalOptionsProps } from '../../SoftphoneModalContext/Context';

export const useIQModal = () => {
  const [iqModalOptions, setIQModalOptions] = useState<ISoftphoneModalOptionsProps | undefined>();
  const [isIQModalOpen, setIsIQModalOpen] = useState(false);

  const openIQModal = (options?: ISoftphoneModalOptionsProps) => {
    setIsIQModalOpen(true);
    setIQModalOptions(options);
  };

  const closeIQModal = () => {
    setIsIQModalOpen(false);
    iqModalOptions?.onClose?.();
  };

  const handleClearIQModalContent = () => {
    setIQModalOptions(undefined);
  };

  return {
    actions: {
      openIQModal,
      closeIQModal,
      handleClearIQModalContent,
    },
    state: {
      isIQModalOpen,
      iqModalOptions,
    },
  };
};
